import { enumManagers } from '@chirp/enums';
import { Table } from 'antd';
import { orderBy } from 'lodash';
import React from 'react';

import { TableCellDescriptions } from '../../../../components/TableCellDescriptions';
import { AccessPointModel } from '../../../AccessPoint/model';
import { HubModel } from '../../../Hub/model';

import { EmergencyScenarioSyncStatusColumn } from './EmergencyScenarioSyncStatusColumn';
import type { IEmergencyScenarioMonitoringProps } from './typings';

export const EmergencyScenarioHubMonitoring: React.FC<IEmergencyScenarioMonitoringProps> = (props) => {
  const { monitoredHubs, monitoredAccessPoints } = props.emergencyScenarioMonitoring;

  const sortedMonitoredHubs = orderBy(monitoredHubs, [
    h => h.syncStatus,
    h => h.hub.deviceType,
    h => h.hub.name,
  ], ['desc', 'desc', 'asc']);

  return (
    <Table
      dataSource={sortedMonitoredHubs}
      pagination={false}
      rowKey={({ hub }) => hub.hubId}
      columns={[
        {
          title: 'Hub',
          render: (_, { hub }) => HubModel.routes.renderRowLink(hub),
        },
        {
          title: 'Device Type',
          render: (_, { hub }) => enumManagers.HubDeviceType.getLabel(hub.deviceType),
        },
        {
          title: 'Access Points',
          render: (_, { hub }) => {
            const hubMonitoredAccessPoints = monitoredAccessPoints.filter(a => (
              a.relays.some(r => r.hubId === hub.hubId)
            ));

            const sortedAccessPoints = orderBy(hubMonitoredAccessPoints, a => a.accessPoint.name);

            return (
              <ul style={{ paddingLeft: 0, display: 'block' }}>
                {sortedAccessPoints.map(({ accessPoint }) => (
                  <li key={accessPoint.accessPointId}>
                    {AccessPointModel.routes.renderRowLink(accessPoint)}
                  </li>
                ))}
              </ul>
            );
          },
        },
        {
          title: 'Status',
          render: (_, monitoredHub) => (
            <EmergencyScenarioSyncStatusColumn {...monitoredHub} />
          ),
        },
      ]}
      expandable={{
        rowExpandable: ({ hub }) => !!hub.location,
        expandedRowRender: ({ hub }) => {
          return (
            <div style={{ marginLeft: 50 }}>
              <TableCellDescriptions
                descriptions={{
                  Location: hub.location,
                }}
              />
            </div>
          );
        },
      }}
    />
  );
};
